module.exports = __webpack_public_path__ + "static/media/achievement-happy-camper.05c60896.svg";